import { observable, action } from 'mobx';

export class FundScenariosStore {
  @observable
  isCalculated = false;

  @observable
  isLoading = true;

  @observable
  fundInvestments = [] as any[];

  @observable
  openFundInvestments = [];

  @action
  setIsCalculated(isCalculated: boolean) {
    this.isCalculated = isCalculated;
  }

  @action
  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @action
  setFundInvestments(fundInvestments: any) {
    this.fundInvestments = fundInvestments;
  }
}
